registerComponent("sections/topo-editorial", function (component) {
/**
 * sections/topo-editorial — a coreografia do topo da home, em "Sobre o ASA"
 * (09/09, ADR 0069). Três coisas, todas só com movimento permitido — sem ele
 * o CSS fica no estado final, inteiro e parado:
 *
 * 1. revela o topo (`.is-in`, `Asa.revelar`), que só arma a luz: o título, o
 *    lead e a assinatura não têm entrada desde 22/09;
 * 2. a TRANSIÇÃO DO TOPO, em faixa: COMEÇA quando o painel seguinte já cobriu
 *    o título — a rolagem em que o topo dele encosta no topo do título, que é
 *    o respiro mais a altura do título (112 + 136 = 248 na âncora de 1440) —
 *    e TERMINA quando o painel encosta na base do header (a posição do painel
 *    no documento menos a altura do header, 560 − 88 = 472). `Asa.transicaoDoTopo`
 *    publica `--topo-inicio` + `--topo-alcance` + `topo--nativo` ou, no
 *    fallback, `--topo-t` a cada quadro. Medido por altura, estilo computado
 *    e pela caixa do PAINEL (que não é `sticky`): a posição de um `sticky`
 *    mente quando a página abre já rolada (F5 no meio);
 *    Terminada a faixa — o painel encostado na base do header — o <html>
 *    recebe `js-topo-encostado`: é o que pinta o fundo do header,
 *    transparente até então (ADR 0073);
 * 3. o DOURADO SAI quando o painel cobre o topo inteiro (`js-topo-saindo` no
 *    <html>, lido por _base.less e pelas camadas do grafismo): a troca
 *    acontece atrás do painel e é SECA, sem transição (ADR 0073) — por isso
 *    não há classe de armação como a `js-produtos-anim` da home. E, terminada
 *    a faixa, a assinatura passa a `fixed` (`topo--marca-fixa`) para o
 *    monograma ficar na barra até o fim da página — o `sticky` soltaria com o
 *    palco.
 *
 * ⚠️ O TÍTULO É OPCIONAL (14/09, ADR 0041): nas páginas legadas sem título de
 * hero o topo é só a faixa com a assinatura, e a faixa da transição começa
 * quando o painel cobre o respiro abaixo dela — a mesma conta, sem a altura
 * do título.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

const inner = component.querySelector('.topo__inner');
const titulo = component.querySelector('.topo__title');
// Só "Nossa história" tem lead (a variante `topo--lead`); ele entra na conta do
// começo da faixa, porque o painel passa por ele antes de chegar ao título.
const lead = component.querySelector('.topo__lead');
const painel = component.nextElementSibling;
const header = document.querySelector('.header');

if (Asa.movimentoPermitido() && inner && painel) {
    Asa.revelar(component);

    /* A posição do painel no documento — 560 na âncora de 1440. A caixa dele
       não é `sticky`, então rect + rolagem é a posição de layout em qualquer
       estado. Remedida a cada `medir()` (load e resize). */
    let painelTopo = 0;

    const medirPainel = () => {
        painelTopo = painel.getBoundingClientRect().top + window.scrollY;

        return painelTopo;
    };

    const transicao = Asa.transicaoDoTopo(component, {
        medirInicio: () => {
            const respiro = parseFloat(getComputedStyle(inner).paddingBottom) || 0;
            const alturaDoTitulo = titulo ? titulo.offsetHeight : 0;

            if (!lead) {
                return respiro + alturaDoTitulo;
            }

            const vao = parseFloat(getComputedStyle(lead).marginTop) || 0;

            return respiro + lead.offsetHeight + vao + alturaDoTitulo;
        },
        medir: () => medirPainel() - (header ? header.offsetHeight : 0),
        classeNativo: 'topo--nativo',
        propAlcance: '--topo-alcance',
        propInicio: '--topo-inicio',
        propT: '--topo-t',
    });

    /* O dourado sai com o topo coberto. Um quadro por rajada, pelo agendador
       de `Asa.aoRolar`. */
    const raiz = document.documentElement;
    let saindo = null;

    Asa.aoRolar((y) => {
        // O fim da faixa: o painel ENCOSTA na base do header e o monograma
        // aterra na barra, no mesmo quadro (o alcance é a posição do painel
        // menos o header). A assinatura deixa o palco e fica presa à tela
        // (`topo--marca-fixa`), e o header ganha o fundo (`js-topo-encostado`,
        // lido por _header.less — ADR 0073): até aqui a barra era transparente
        // e mostrava o gradiente e o grafismo do topo; deste quadro em diante
        // o painel passa por baixo dela.
        const encostado = transicao.alcance() > 0 && y >= transicao.alcance();

        component.classList.toggle('topo--marca-fixa', encostado);
        raiz.classList.toggle('js-topo-encostado', encostado);

        const agora = painelTopo > 0 && y >= painelTopo;

        if (agora === saindo) {
            return;
        }

        raiz.classList.toggle('js-topo-saindo', agora);
        saindo = agora;
    });
}

});
